module.exports = __webpack_public_path__ + "static/img/apple-m.b8b2fe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/apple-m.jpg
// module id = KwLr
// module chunks = 0